import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PopinComponent } from '../popin/popin.component';

/*
  In-widget confirmation before going back to the bank choice. Replaces the
  native confirm(): webviews ship no JS dialogs unless the host app wires
  them, and the native box leaks the widget's internal domain to the user.
  Closing the popin any other way than OK counts as a cancellation.
*/
@Component({
  selector: 'app-go-back-to-bank-choice-popin',
  templateUrl: './go-back-to-bank-choice-popin.component.html',
  standalone: true,
  imports: [PopinComponent, TranslateModule],
})
export class GoBackToBankChoicePopinComponent {
  @Input() show = false;
  @Output() confirmed = new EventEmitter<void>();
  @Output() cancelled = new EventEmitter<void>();
}
